import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { ButtonWithText } from "../utils/ButtonWithText";


export class ErrorLayer extends Phaser.GameObjects.Container {

    private scaledItemsContainer: Phaser.GameObjects.Container;

    private returnFunction: any;

    constructor(scene: Phaser.Scene, titleString: string, textString: string, func: any) {
        
        super(scene);

        this.returnFunction = func;

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x000000, .75);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        background.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        this.add(background);

        this.scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        this.scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        this.scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        this.scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(this.scaledItemsContainer);

        const menuBackground = new Phaser.GameObjects.Graphics(this.scene);
        menuBackground.fillStyle(0x000000, .75);
        menuBackground.fillRoundedRect(-180, -275, 360, 550, 10);
        menuBackground.lineStyle(3, 0xacfffa);
        menuBackground.strokeRoundedRect(-180, -275, 360, 550, 10);
        this.scaledItemsContainer.add(menuBackground);

        const ribbon = new Phaser.GameObjects.Image(this.scene, 0, -260, "texture_atlas_3", "bar");
        ribbon.setScale(.9, 1.2);
        this.scaledItemsContainer.add(ribbon);

        const title = new Phaser.GameObjects.Text(this.scene, 0, -260, titleString, {fontFamily: "Baloo", fontSize: "40px", color: "#FFFFFF"});
        title.setOrigin(.5);
        title.setStroke("#9a2954", 6);
        this.scaledItemsContainer.add(title);

        if (textString.includes("Invalid atempt to spread non-iterable instance")) {
            console.log(textString);
            textString = "Payment couldn’t be conducted.";
        } else if (textString.includes("transaction declares authority")) {
            console.log(textString);
            textString = "Wallet account doesn’t match. Check if Wax Cloud Wallet is logged correctly.";
        }

        const text = new Phaser.GameObjects.Text(this.scene, 0, -10, textString, {fontFamily: "Baloo", fontSize: "30px", color: "#FFFFFF", align: "center"});
        text.setOrigin(.5);
        text.setWordWrapWidth(340);
        this.scaledItemsContainer.add(text);

        const proceedButtonImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_4", "btn_green");
        const proceedButtonLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, "TRY\nAGAIN", {fontFamily: "Baloo", fontSize: "30px", color: "#FFFFFF", align: "center", wordWrap: { width: 180, useAdvancedWrap: true}});
        proceedButtonLabel.setOrigin(.5);
        proceedButtonLabel.lineSpacing = -10;
        proceedButtonLabel.setStroke("#54bf11", 4);

        let tryAgainButton = new ButtonWithText(this.scene, proceedButtonImage, proceedButtonLabel, this.onTryAgainDown, this);
        tryAgainButton.y = 210;
        this.scaledItemsContainer.add(tryAgainButton);
    }

    private onTryAgainDown(): void {

        this.returnFunction();
        this.destroy();
    }
}
